import type { Import } from '../import/import.interface';
import { IMPORT_KIND, IMPORT_STATE } from '../import/import.interface';
import { baseDocumentFactory } from './base-document.factory';
import { ObjectFactory } from './object.factory';

export class ImportFactory extends ObjectFactory<Import> {
  protected getDefaults(): Import {
    return {
      ...baseDocumentFactory.build(),
      errors: { global: [], lines: [] },
      fileName: 'orders.csv',
      filePath: 'imports/orders/2026/09/09/uuid.csv',
      kind: IMPORT_KIND.ORDERS,
      linesCount: {
        createError: 0,
        created: 0,
        parseError: 0,
        read: 0,
        skipped: 0,
        submitted: 0,
        total: 0,
        updateError: 0,
        updated: 0,
      },
      siteIds: [],
      spaceIds: [],
      state: IMPORT_STATE.PENDING,
      user: { firstName: 'Alice', id: 'aabbccddeeff001122334455', lastName: 'Doe' },
    };
  }
}

export const importFactory = new ImportFactory();
